/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 RadioSchedule = {
    changeDay: function() {
        var button = $(this);

        var id = button.data('id');

        $("#radio-schedule-list").animate({'opacity': 0.5});

        $.ajax({
            url: '/a/radio/schedule/changeDay',
            type: 'POST',
            dataType: 'json',
            data: {'day': id},
        }).done(function(data) {
            $("#radio-schedule-list").animate({'opacity': 1}).html(data.html);

            $(".radio-schedule-box-times > div").removeClass('col-6').addClass('col-1').find('.box-time').removeClass('active');

            button.addClass('active');
            button.parent().removeClass('col-1').addClass('col-6');

            Main.plugins.tooltip();
        });
    },
    init: function() {
        $(".radio-schedule-box-times").on('click', '.box-time:not(.active)', RadioSchedule.changeDay);
    }
};
